// Import required dependencies from React and various libraries
import { StrictMode } from "react";
import { Provider as ReduxProvider } from "react-redux";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App"; // Main App component
import reportWebVitals from "./reportWebVitals"; // Utility for performance measurement
import { store } from "./redux/store"; // Redux store for state management
import { CssBaseline } from "@mui/material";
import { CustomThemeProvider } from "./theme/CustomThemeProvider";

// Create a root React DOM element to render the React app
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Render the main app using React's StrictMode for better error detection
root.render(
  <StrictMode>
    {/* Date localization provider using AdapterDayjs */}
    {/* Redux state management provider */}
    <ReduxProvider store={store}>
      {/* React Router for app routing */}
      <Router>
        {/* Custom Theme provider for consistent styling */}
        <CustomThemeProvider>
          <CssBaseline />
          <App />
        </CustomThemeProvider>
      </Router>
    </ReduxProvider>
  </StrictMode>
);

// Utility to measure and report web vitals for app performance
// (Currently just a function call, can be modified to send data to analytics endpoint)
reportWebVitals();
